import Vue from 'vue';

import App from './App.vue';
import Home from './layouts/Home/Home.vue'
import Order from './layouts/Order/Order.vue'

import Vuex from 'vuex';
import VueRouter from 'vue-router'
import Notifications from 'vue-notification'
import VuePhoneNumberInput from 'vue-phone-number-input';
import Sticky from 'vue-sticky-directive'
import vuescroll from 'vuescroll';

import 'vue-phone-number-input/dist/vue-phone-number-input.css';


import store from './store'

import { i18n } from './i18n-setup'

Vue.config.productionTip = false
import VueModalTor from "vue-modaltor";
Vue.use(VueModalTor);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.use(Sticky)
Vue.use(vuescroll, { ops: {
  bar: {
    background: 'grey',
    keepShow: false,
    opacity: 0.5,
    minSize: 0.2
  },
  scrollPanel: {
    speed: 200,
  },
  vuescroll: {
    wheelScrollDuration: 0,
    wheelDirectionReverse: false
  }
}, name: 'vuescroll' });

Vue.use(VueRouter)

const routes = [
  { path: '',
    component: App,
    children: [{
      path: '', component: Home, name: 'home'
    }, {
      path: 'order/:id', name: 'order', component: Order
    }
  ]},
]

const router = new VueRouter({
  routes,
  base: './',
  mode: 'history'
})

Vue.use(Notifications);
Vue.use(Vuex);

new Vue({
  store,
  router,
  render: h => h(App),
  i18n
}).$mount('#app')
